<template>
  <button class="zoombox-button" @click="zoom">
    <bpb-icon
      :icon="isZoomed ? 'i-magnify--minus' : 'i-magnify--plus'"
      :label-path="isZoomed ? 'zoombox.zoom-out' : 'zoombox.zoom-in'"
    ></bpb-icon>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isZoomed: 'zoombox/isZoomed',
    }),
  },
  methods: {
    zoom() {
      this.$store.dispatch('zoombox/update', { isZoomed: !this.isZoomed });
    },
  },
};
</script>
